var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_vm._l((_vm.ChildNodes),function(childNode){return [_c('dash-node',{attrs:{"Node":childNode,"Action":_vm.Action}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }